/* eslint-disable perfectionist/sort-enums,perfectionist/sort-objects */

export enum PermissionName {
  TABS_MAP_TAB = 'tabsMapTab',
  TABS_RESERVATIONS_TAB = 'tabsReservationsTab',
  TABS_EQUIPMENT_TAB = 'tabsEquipmentTab',
  TABS_CRANE_TAB = 'tabsCraneTab',
  TABS_PEOPLE_TAB = 'tabsPeopleTab',
  TABS_REPORTS_TAB = 'tabsReportsTab',
  TABS_ACTIONS_TAB = 'tabsActionsTab',

  MAP_REAL_TIME_VIEW = 'mapRealTimeView',
  MAP_SHOW_FILTER_EQUIPMENT = 'mapShowFilterEquipment',
  MAP_SHOW_FILTER_READERS = 'mapShowFilterReaders',
  MAP_SHOW_FILTER_PEOPLE_FROM_OWN_FIRM = 'mapShowFilterPeopleFromOwnFirm',
  MAP_SHOW_FILTER_PEOPLE_FROM_OTHER_FIRMS = 'mapShowFilterPeopleFromOtherFirms',
  MAP_SHOW_FILTER_PUBLIC_PEOPLE_GROUPS_USER_IS_INCLUDED_IN = 'mapShowFilterPublicPeopleGroupsUserIsIncludedIn',
  MAP_SHOW_FILTER_ALL_PUBLIC_PEOPLE_GROUPS = 'mapShowFilterAllPublicPeopleGroups',
  MAP_SHOW_FILTER_USERS_OWN_PRIVATE_PEOPLE_GROUPS = 'mapShowFilterUsersOwnPrivatePeopleGroups',
  MAP_SHOW_FILTER_PUBLIC_EQUIPMENT_GROUPS = 'mapShowFilterPublicEquipmentGroups',
  MAP_SHOW_FILTER_USERS_OWN_PRIVATE_EQUIPMENT_GROUPS = 'mapShowFilterUsersOwnPrivateEquipmentGroups',
  MAP_CLICK_ON_ITEM_IN_SIDEBAR_LIST_POPS_UP_ITEM_LABEL_ON_MAP = 'mapClickOnItemInSidebarListPopsUpItemLabelOnMap',
  MAP_CREATE_EDIT_RED_ZONES = 'mapCreateEditRedZones',
  MAP_SHOW_FILTER_RED_ZONES = 'mapShowFilterRedZones',
  MAP_CREATE_EDIT_PUBLIC_WORK_ZONES = 'mapCreateEditPublicWorkZones',
  MAP_SHOW_FILTER_PUBLIC_WORK_ZONES = 'mapShowFilterPublicWorkZones',
  MAP_CREATE_EDIT_PRIVATE_WORK_ZONES = 'mapCreateEditPrivateWorkZones',
  MAP_SHOW_FILTER_PRIVATE_WORK_ZONES = 'mapShowFilterPrivateWorkZones',
  MAP_ACTIVATE_DEACTIVATE_ZONES = 'mapActivateDeactivateZones',
  MAP_HISTORICAL_VIEW = 'mapHistoricalView',
  MAP_SHOW_HISTORY_FOR_PEOPLE_IN_OWN_FIRM = 'mapShowHistoryForPeopleInOwnFirm',
  MAP_SHOW_HISTORY_FOR_ALL_PEOPLE = 'mapShowHistoryForAllPeople',
  MAP_SHOW_MOVEMENT_TRAIL_IN_HISTORY_MODE = 'mapShowMovementTrailInHistoryMode',
  MAP_HISTORICAL_TIME_IN_ZONE = 'mapHistoricalTimeInZone',
  MAP_HISTORICAL_ZONE_ENTRY_EXIT_TIME = 'mapHistoricalZoneEntryExitTime',
  MAP_MINI_MAP = 'mapMiniMap',
  MAP_ZOOM_IN_OUT_BUTTONS = 'mapZoomInOutButtons',
  MAP_ROTATE_BUTTONS = 'mapRotateButtons',
  MAP_FULL_SITE_VIEW = 'mapFullSiteView',
  MAP_CLICK_ON_MAP_TO_HIDE_ALL_ITEM_LABEL_POPUPS = 'mapClickOnMapToHideAllItemLabelPopups',
  MAP_CREATE_EDIT_ZONE_SIDE_BAR = 'mapCreateEditZoneSideBar',
  MAP_SHOW_EDIT_INACTIVE_GEOFENCES = 'mapShowEditInactiveGeofences',
  MAP_EDIT_REDZONE_ALLOWED_ASSET_LIST = 'mapEditRedzoneAllowedAssetList',
  MAP_DEFINE_ACTIVE_TIME_FOR_RED_ZONES_IN_CREATE_EDIT_ZONE = 'mapDefineActiveTimeForRedZonesInCreateEditZone',

  // RESERVATION_CALENDAR_VIEW = 'reservationCalendarView',
  // RESERVATION_LIST_VIEW = 'reservationListView',
  // RESERVATION_AUTO_APPROVAL_SETTINGS_BUTTON = 'reservationAutoApprovalSettingsButton',
  // RESERVATION_SHOW_OWN_FIRM_RESERVATIONS = 'reservationShowOwnFirmReservations',
  // RESERVATION_SHOW_OTHER_FIRM_RESERVATIONS = 'reservationShowOtherFirmReservations',
  // RESERVATION_SHOW_OWN_FIRM_RESERVATION_HISTORY = 'reservationShowOwnFirmReservationHistory',
  // RESERVATION_SHOW_OTHER_FIRM_RESERVATION_HISTORY = 'reservationShowOtherFirmReservationHistory',
  // RESERVATION_HIGHLIGHT_LABEL_CONFLICTING_RESERVATION_REQUESTS = 'reservationHighlightLabelConflictingReservationRequests',
  // RESERVATION_RESERVATION_DRAFTS = 'reservationReservationDrafts',

  EQUIPMENT_SHOW_ALL_EQUIPMENT = 'equipmentShowAllEquipment',
  EQUIPMENT_SHOW_EQUIPMENT_PRICE = 'equipmentShowEquipmentPrice',
  EQUIPMENT_ADD_EDIT_EQUIPMENT = 'equipmentAddEditEquipment',
  EQUIPMENT_ADD_RESERVATION_BUTTON = 'equipmentAddReservationButton',
  EQUIPMENT_SHOW_TOTAL_EQUIPMENT_AND_EQUIPMENT_IN_USE_STATS = 'equipmentShowTotalEquipmentAndEquipmentInUseStats',
  EQUIPMENT_SHOW_TAG_ID = 'equipmentShowTagId',
  EQUIPMENT_CREATE_EDIT_PUBLIC_EQUIPMENT_GROUPS = 'equipmentCreateEditPublicEquipmentGroups',
  EQUIPMENT_VIEW_PUBLIC_EQUIPMENT_GROUPS = 'equipmentViewPublicEquipmentGroups',
  EQUIPMENT_CREATE_PRIVATE_EQUIPMENT_GROUPS = 'equipmentCreatePrivateEquipmentGroups',
  EQUIPMENT_VIEW_PRIVATE_EQUIPMENT_GROUPS = 'equipmentViewPrivateEquipmentGroups',
  EQUIPMENT_ON_INDIVIDUAL_EQUIPMENT_PAGE_SHOW_RENTAL_COMPANY = 'equipmentOnIndividualEquipmentPageShowRentalCompany',
  EQUIPMENT_ON_INDIVIDUAL_EQUIPMENT_PAGE_SHOW_RESERVATION_HISTORY = 'equipmentOnIndividualEquipmentPageShowReservationHistory',
  EQUIPMENT_ON_INDIVIDUAL_EQUIPMENT_PAGE_SHOW_PRICE = 'equipmentOnIndividualEquipmentPageShowPrice',
  EQUIPMENT_ADD_EDIT_EQUIPMENT_TYPES_SUBTYPES = 'equipmentAddEditEquipmentTypesSubtypes',
  EQUIPMENT_SAVE_BUTTON_FOR_EDIT_INACTIVE_ITEMS = 'equipmentSaveButtonForEditInactiveItems',
  EQUIPMENT_SHOW_ON_MAP_BUTTON_FOR_TABLES = 'equipmentShowOnMapButtonForTables',
  EQUIPMENT_AVAILABILITY_COLUMN = 'equipmentAvailabilityColumn',

  PEOPLE_SHOW_ALL_FIRMS = 'peopleShowAllFirms',
  PEOPLE_CLICK_OWN_FIRM_ACCESS_TO_FIRM_PAGE_FOR_OWN_FIRM = 'peopleClickOwnFirmAccessToFirmPageForOwnFirm',
  PEOPLE_CLICK_OTHER_FIRMS_ACCESS_TO_FIRM_PAGE_FOR_OTHER_FIRMS = 'peopleClickOtherFirmsAccessToFirmPageForOtherFirms',
  PEOPLE_INVITE_NEW_PEOPLE = 'peopleInviteNewPeople',
  PEOPLE_ON_FIRM_PAGE_SHOW_TAG_ID = 'peopleOnFirmPageShowTagId',
  PEOPLE_EDIT_OWN_FIRM = 'peopleEditOwnFirm',
  PEOPLE_EDIT_ALL_FIRMS = 'peopleEditAllFirms',
  PEOPLE_EDIT_PEOPLE_IN_OWN_FIRM = 'peopleEditPeopleInOwnFirm',
  PEOPLE_EDIT_ALL_PEOPLE = 'peopleEditAllPeople',
  PEOPLE_ON_FIRM_PAGE_SHOW_UNRESOLVED_ACTIONS = 'peopleOnFirmPageShowUnresolvedActions',
  PEOPLE_ON_FIRM_PAGE_SHOW_CURRENT_ZONE = 'peopleOnFirmPageShowCurrentZone',
  PEOPLE_ON_FIRM_PAGE_SHOW_TOTAL_PEOPLE_AND_PEOPLE_ON_SITE = 'peopleOnFirmPageShowTotalPeopleAndPeopleOnSite',
  PEOPLE_ACCESS_INDIVIDUAL_PERSON_PAGE_FOR_PEOPLE_IN_OWN_FIRM = 'peopleAccessIndividualPersonPageForPeopleInOwnFirm',
  PEOPLE_ACCESS_INDIVIDUAL_PERSON_PAGE_FOR_PEOPLE_IN_OTHER_FIRMS = 'peopleAccessIndividualPersonPageForPeopleInOtherFirms',
  PEOPLE_ON_INDIVIDUAL_PERSON_PAGE_SEE_UNRESOLVED_ACTIONS = 'peopleOnIndividualPersonPageSeeUnresolvedActions',
  PEOPLE_ON_INDIVIDUAL_PERSON_PAGE_SEE_ARCHIVED_ACTIONS = 'peopleOnIndividualPersonPageSeeArchivedActions',
  PEOPLE_ON_INDIVIDUAL_PERSON_PAGE_SEE_EMAIL_PHONE = 'peopleOnIndividualPersonPageSeeEmailPhone',
  PEOPLE_ON_INDIVIDUAL_PERSON_PAGE_SEE_ZPS_ACCESS_LIST = 'peopleOnIndividualPersonPageSeeZpsAccessList',
  PEOPLE_CREATE_EDIT_PUBLIC_PEOPLE_GROUPS = 'peopleCreateEditPublicPeopleGroups',
  PEOPLE_VIEW_PUBLIC_PEOPLE_GROUPS = 'peopleViewPublicPeopleGroups',
  PEOPLE_CREATE_EDIT_PRIVATE_PEOPLE_GROUPS_WITH_PEOPLE_FROM_ALL_FIRMS = 'peopleCreateEditPrivatePeopleGroupsWithPeopleFromAllFirms',
  PEOPLE_CREATE_EDIT_PRIVATE_PEOPLE_GROUPS_WITH_PEOPLE_FROM_OWN_FIRM = 'peopleCreateEditPrivatePeopleGroupsWithPeopleFromOwnFirm',
  PEOPLE_VIEW_PRIVATE_PEOPLE_GROUPS = 'peopleViewPrivatePeopleGroups',
  PEOPLE_SAVE_BUTTON_FOR_EDIT_INACTIVE_ITEMS = 'peopleSaveButtonForEditInactiveItems',
  PEOPLE_SHOW_ON_MAP_BUTTON_FOR_TABLES = 'peopleShowOnMapButtonForTables',

  REPORTS_TIME_IN_ZONE_REPORT_FOR_EQUIPMENT = 'reportsTimeInZoneReportForEquipment',
  REPORTS_TIME_IN_ZONE_REPORT_FOR_PEOPLE_IN_OWN_FIRM = 'reportsTimeInZoneReportForPeopleInOwnFirm',
  REPORTS_TIME_IN_ZONE_REPORT_FOR_PEOPLE_IN_OTHER_FIRMS = 'reportsTimeInZoneReportForPeopleInOtherFirms',
  REPORTS_UTILIZATION_REPORT = 'reportsUtilizationReport',
  REPORTS_TRIPS_REPORT = 'reportsTripsReport',
  REPORTS_SITE_PRESENCE_REPORT_FOR_OWN_FIRM = 'reportsSitePresenceReportForOwnFirm',
  REPORTS_SITE_PRESENCE_REPORT_FOR_PEOPLE = 'reportsSitePresenceReportForPeople',
  REPORTS_TAG_DIAGNOSTICS_REPORT_FOR_EQUIPMENT = 'reportsTagDiagnosticsReportForEquipment',
  REPORTS_TAG_DIAGNOSTICS_REPORT_FOR_PEOPLE_IN_OWN_FIRM = 'reportsTagDiagnosticsReportForPeopleInOwnFirm',
  REPORTS_TAG_DIAGNOSTICS_REPORT_FOR_PEOPLE_IN_OTHER_FIRMS = 'reportsTagDiagnosticsReportForPeopleInOtherFirms',
  REPORTS_AUDIT_LOG_REPORT = 'reportsAuditLogReport',
  REPORTS_PLAN_UPLOAD_REPORT = 'reportsPlanUploadReport',
  REPORTS_ZONE_ENTRY_EXIT_TIMES_REPORT = 'reportsZoneEntryExitTimesReport',

  ACTIONS_ALL_VIEW = 'actionsAllView',
  ACTIONS_SYSTEM = 'actionsSystem',
  ACTIONS_SAFETY = 'actionsSafety',
  ACTIONS_EQUIPMENT = 'actionsEquipment',
  ACTIONS_ZONES = 'actionsZones',
  ACTIONS_PROGRESS = 'actionsProgress',
  ACTIONS_ARCHIVE = 'actionsArchive',

  DROPDOWN_SITE_SELECTION = 'dropdownSiteSelection',
  DROPDOWN_LANGUAGE_SELECTOR = 'dropdownLanguageSelector',
  DROPDOWN_SETTINGS_LINK = 'dropdownSettingsLink',
  DROPDOWN_SIGN_OUT_BUTTON = 'dropdownSignOutButton',
  DROPDOWN_LICENSES_LINK = 'dropdownLicensesLink',
  DROPDOWN_RELEASE_NOTES_LINK = 'dropdownReleaseNotesLink',

  SETTINGS_PROFILE_TAB = 'settingsProfileTab',
  SETTINGS_SYSTEM_TAB = 'settingsSystemTab',
  SETTINGS_ON_SYSTEM_TAB_CURRENCY_OPTION = 'settingsOnSystemTabCurrencyOption',
  SETTINGS_SITE_HOURS_TAB = 'settingsSiteHoursTab',
  SETTINGS_SITE_MAP_TAB = 'settingsSiteMapTab',
  SETTINGS_AUTO_APPROVAL_TAB = 'settingsAutoApprovalTab',
  SETTINGS_ACTIONS_TAB = 'settingsActionsTab',
  SETTINGS_DEVICE_MANAGEMENT_TAB = 'settingsDeviceManagementTab',
  SETTINGS_SITE_MANAGEMENT = 'settingsSiteManagement',
  SETTINGS_ZPS_ACCESS_FOR_ALL_USERS = 'settingsZpsAccessForAllUsers',
  SETTINGS_ZPS_ACCESS_FOR_OWN_FIRM = 'settingsZpsAccessForOwnFirm',
  SETTINGS_MANAGE_ACCESS_CONTROL = 'manageAccessControl',

  ALLOW = 'allow',
}

export enum PermissionGroup {
  TABS = 'tabs',
  MAP = 'map',
  // RESERVATIONS = 'reservations',
  EQUIPMENT = 'equipment',
  PEOPLE = 'people',
  REPORTS = 'reports',
  ACTIONS = 'actions',
  DROPDOWN = 'dropdown',
  SETTINGS = 'settings',
}

export const permissionGroups: { [k in PermissionGroup]: PermissionName[] } = {
  [PermissionGroup.TABS]: [
    PermissionName.TABS_MAP_TAB,
    PermissionName.TABS_RESERVATIONS_TAB,
    PermissionName.TABS_EQUIPMENT_TAB,
    PermissionName.TABS_CRANE_TAB,
    PermissionName.TABS_PEOPLE_TAB,
    PermissionName.TABS_REPORTS_TAB,
    PermissionName.TABS_ACTIONS_TAB,
  ],
  [PermissionGroup.MAP]: [
    PermissionName.MAP_REAL_TIME_VIEW,
    PermissionName.MAP_SHOW_FILTER_EQUIPMENT,
    PermissionName.MAP_SHOW_FILTER_READERS,
    PermissionName.MAP_SHOW_FILTER_PEOPLE_FROM_OWN_FIRM,
    PermissionName.MAP_SHOW_FILTER_PEOPLE_FROM_OTHER_FIRMS,
    // PermissionName.MAP_SHOW_FILTER_PUBLIC_PEOPLE_GROUPS_USER_IS_INCLUDED_IN,
    // PermissionName.MAP_SHOW_FILTER_ALL_PUBLIC_PEOPLE_GROUPS,
    // PermissionName.MAP_SHOW_FILTER_USERS_OWN_PRIVATE_PEOPLE_GROUPS,
    // PermissionName.MAP_SHOW_FILTER_PUBLIC_EQUIPMENT_GROUPS,
    // PermissionName.MAP_SHOW_FILTER_USERS_OWN_PRIVATE_EQUIPMENT_GROUPS,
    PermissionName.MAP_CLICK_ON_ITEM_IN_SIDEBAR_LIST_POPS_UP_ITEM_LABEL_ON_MAP,
    PermissionName.MAP_CREATE_EDIT_RED_ZONES,
    PermissionName.MAP_SHOW_FILTER_RED_ZONES,
    PermissionName.MAP_CREATE_EDIT_PUBLIC_WORK_ZONES,
    PermissionName.MAP_SHOW_FILTER_PUBLIC_WORK_ZONES,
    // PermissionName.MAP_CREATE_EDIT_PRIVATE_WORK_ZONES,
    // PermissionName.MAP_SHOW_FILTER_PRIVATE_WORK_ZONES,
    PermissionName.MAP_ACTIVATE_DEACTIVATE_ZONES,
    PermissionName.MAP_HISTORICAL_VIEW,
    PermissionName.MAP_SHOW_HISTORY_FOR_PEOPLE_IN_OWN_FIRM,
    PermissionName.MAP_SHOW_HISTORY_FOR_ALL_PEOPLE,
    PermissionName.MAP_SHOW_MOVEMENT_TRAIL_IN_HISTORY_MODE,
    // PermissionName.MAP_HISTORICAL_TIME_IN_ZONE,
    // PermissionName.MAP_HISTORICAL_ZONE_ENTRY_EXIT_TIME,
    PermissionName.MAP_MINI_MAP,
    PermissionName.MAP_ZOOM_IN_OUT_BUTTONS,
    PermissionName.MAP_ROTATE_BUTTONS,
    PermissionName.MAP_FULL_SITE_VIEW,
    PermissionName.MAP_CLICK_ON_MAP_TO_HIDE_ALL_ITEM_LABEL_POPUPS,
    PermissionName.MAP_CREATE_EDIT_ZONE_SIDE_BAR,
    PermissionName.MAP_SHOW_EDIT_INACTIVE_GEOFENCES,
    // PermissionName.MAP_EDIT_REDZONE_ALLOWED_ASSET_LIST,
    // PermissionName.MAP_DEFINE_ACTIVE_TIME_FOR_RED_ZONES_IN_CREATE_EDIT_ZONE,
  ],
  // [PermissionGroup.RESERVATIONS]: [
  //   PermissionName.RESERVATION_CALENDAR_VIEW,
  //   PermissionName.RESERVATION_LIST_VIEW,
  //   PermissionName.RESERVATION_AUTO_APPROVAL_SETTINGS_BUTTON,
  //   PermissionName.RESERVATION_SHOW_OWN_FIRM_RESERVATIONS,
  //   PermissionName.RESERVATION_SHOW_OTHER_FIRM_RESERVATIONS,
  //   PermissionName.RESERVATION_SHOW_OWN_FIRM_RESERVATION_HISTORY,
  //   PermissionName.RESERVATION_SHOW_OTHER_FIRM_RESERVATION_HISTORY,
  //   PermissionName.RESERVATION_HIGHLIGHT_LABEL_CONFLICTING_RESERVATION_REQUESTS,
  //   PermissionName.RESERVATION_RESERVATION_DRAFTS,
  // ],
  [PermissionGroup.EQUIPMENT]: [
    PermissionName.EQUIPMENT_SHOW_ALL_EQUIPMENT,
    PermissionName.EQUIPMENT_SHOW_EQUIPMENT_PRICE,
    PermissionName.EQUIPMENT_ADD_EDIT_EQUIPMENT,
    PermissionName.EQUIPMENT_ADD_RESERVATION_BUTTON,
    PermissionName.EQUIPMENT_SHOW_TOTAL_EQUIPMENT_AND_EQUIPMENT_IN_USE_STATS,
    PermissionName.EQUIPMENT_SHOW_TAG_ID,
    // PermissionName.EQUIPMENT_CREATE_EDIT_PUBLIC_EQUIPMENT_GROUPS,
    // PermissionName.EQUIPMENT_VIEW_PUBLIC_EQUIPMENT_GROUPS,
    // PermissionName.EQUIPMENT_CREATE_PRIVATE_EQUIPMENT_GROUPS,
    // PermissionName.EQUIPMENT_VIEW_PRIVATE_EQUIPMENT_GROUPS,
    PermissionName.EQUIPMENT_ON_INDIVIDUAL_EQUIPMENT_PAGE_SHOW_RENTAL_COMPANY,
    PermissionName.EQUIPMENT_ON_INDIVIDUAL_EQUIPMENT_PAGE_SHOW_RESERVATION_HISTORY,
    PermissionName.EQUIPMENT_ON_INDIVIDUAL_EQUIPMENT_PAGE_SHOW_PRICE,
    PermissionName.EQUIPMENT_ADD_EDIT_EQUIPMENT_TYPES_SUBTYPES,
    PermissionName.EQUIPMENT_SAVE_BUTTON_FOR_EDIT_INACTIVE_ITEMS,
    PermissionName.EQUIPMENT_SHOW_ON_MAP_BUTTON_FOR_TABLES,
    PermissionName.EQUIPMENT_AVAILABILITY_COLUMN,
  ],
  [PermissionGroup.PEOPLE]: [
    PermissionName.PEOPLE_SHOW_ALL_FIRMS,
    PermissionName.PEOPLE_CLICK_OWN_FIRM_ACCESS_TO_FIRM_PAGE_FOR_OWN_FIRM,
    PermissionName.PEOPLE_CLICK_OTHER_FIRMS_ACCESS_TO_FIRM_PAGE_FOR_OTHER_FIRMS,
    PermissionName.PEOPLE_INVITE_NEW_PEOPLE,
    PermissionName.PEOPLE_ON_FIRM_PAGE_SHOW_TAG_ID,
    PermissionName.PEOPLE_EDIT_OWN_FIRM,
    PermissionName.PEOPLE_EDIT_ALL_FIRMS,
    PermissionName.PEOPLE_EDIT_PEOPLE_IN_OWN_FIRM,
    PermissionName.PEOPLE_EDIT_ALL_PEOPLE,
    // PermissionName.PEOPLE_ON_FIRM_PAGE_SHOW_UNRESOLVED_ACTIONS,
    PermissionName.PEOPLE_ON_FIRM_PAGE_SHOW_CURRENT_ZONE,
    PermissionName.PEOPLE_ON_FIRM_PAGE_SHOW_TOTAL_PEOPLE_AND_PEOPLE_ON_SITE,
    PermissionName.PEOPLE_ACCESS_INDIVIDUAL_PERSON_PAGE_FOR_PEOPLE_IN_OWN_FIRM,
    PermissionName.PEOPLE_ACCESS_INDIVIDUAL_PERSON_PAGE_FOR_PEOPLE_IN_OTHER_FIRMS,
    // PermissionName.PEOPLE_ON_INDIVIDUAL_PERSON_PAGE_SEE_UNRESOLVED_ACTIONS,
    // PermissionName.PEOPLE_ON_INDIVIDUAL_PERSON_PAGE_SEE_ARCHIVED_ACTIONS,
    PermissionName.PEOPLE_ON_INDIVIDUAL_PERSON_PAGE_SEE_EMAIL_PHONE,
    PermissionName.PEOPLE_ON_INDIVIDUAL_PERSON_PAGE_SEE_ZPS_ACCESS_LIST,
    // PermissionName.PEOPLE_CREATE_EDIT_PUBLIC_PEOPLE_GROUPS,
    // PermissionName.PEOPLE_VIEW_PUBLIC_PEOPLE_GROUPS,
    // PermissionName.PEOPLE_CREATE_EDIT_PRIVATE_PEOPLE_GROUPS_WITH_PEOPLE_FROM_ALL_FIRMS,
    // PermissionName.PEOPLE_CREATE_EDIT_PRIVATE_PEOPLE_GROUPS_WITH_PEOPLE_FROM_OWN_FIRM,
    // PermissionName.PEOPLE_VIEW_PRIVATE_PEOPLE_GROUPS,
    PermissionName.PEOPLE_SAVE_BUTTON_FOR_EDIT_INACTIVE_ITEMS,
    // PermissionName.PEOPLE_SHOW_ON_MAP_BUTTON_FOR_TABLES,
  ],
  [PermissionGroup.REPORTS]: [
    PermissionName.REPORTS_TIME_IN_ZONE_REPORT_FOR_EQUIPMENT,
    PermissionName.REPORTS_TIME_IN_ZONE_REPORT_FOR_PEOPLE_IN_OWN_FIRM,
    PermissionName.REPORTS_TIME_IN_ZONE_REPORT_FOR_PEOPLE_IN_OTHER_FIRMS,
    PermissionName.REPORTS_UTILIZATION_REPORT,
    PermissionName.REPORTS_TRIPS_REPORT,
    // PermissionName.REPORTS_SITE_PRESENCE_REPORT_FOR_OWN_FIRM,
    PermissionName.REPORTS_SITE_PRESENCE_REPORT_FOR_PEOPLE,
    PermissionName.REPORTS_TAG_DIAGNOSTICS_REPORT_FOR_EQUIPMENT,
    // PermissionName.REPORTS_TAG_DIAGNOSTICS_REPORT_FOR_PEOPLE_IN_OWN_FIRM,
    // PermissionName.REPORTS_TAG_DIAGNOSTICS_REPORT_FOR_PEOPLE_IN_OTHER_FIRMS,
    PermissionName.REPORTS_AUDIT_LOG_REPORT,
    // PermissionName.REPORTS_PLAN_UPLOAD_REPORT,
    PermissionName.REPORTS_ZONE_ENTRY_EXIT_TIMES_REPORT,
  ],
  [PermissionGroup.ACTIONS]: [
    PermissionName.ACTIONS_ALL_VIEW,
    PermissionName.ACTIONS_SYSTEM,
    PermissionName.ACTIONS_SAFETY,
    PermissionName.ACTIONS_EQUIPMENT,
    PermissionName.ACTIONS_ZONES,
    // PermissionName.ACTIONS_PROGRESS,
    PermissionName.ACTIONS_ARCHIVE,
  ],
  [PermissionGroup.DROPDOWN]: [
    PermissionName.DROPDOWN_SITE_SELECTION,
    PermissionName.DROPDOWN_LANGUAGE_SELECTOR,
    PermissionName.DROPDOWN_SETTINGS_LINK,
    PermissionName.DROPDOWN_SIGN_OUT_BUTTON,
    PermissionName.DROPDOWN_LICENSES_LINK,
    PermissionName.DROPDOWN_RELEASE_NOTES_LINK,
  ],
  [PermissionGroup.SETTINGS]: [
    PermissionName.SETTINGS_PROFILE_TAB,
    // PermissionName.SETTINGS_SYSTEM_TAB,
    // PermissionName.SETTINGS_ON_SYSTEM_TAB_CURRENCY_OPTION,
    PermissionName.SETTINGS_SITE_HOURS_TAB,
    PermissionName.SETTINGS_SITE_MAP_TAB,
    PermissionName.SETTINGS_AUTO_APPROVAL_TAB,
    PermissionName.SETTINGS_ACTIONS_TAB,
    PermissionName.SETTINGS_DEVICE_MANAGEMENT_TAB,
    PermissionName.SETTINGS_SITE_MANAGEMENT,
    // PermissionName.SETTINGS_ZPS_ACCESS_FOR_ALL_USERS,
    PermissionName.SETTINGS_ZPS_ACCESS_FOR_OWN_FIRM,
  ],
};

export enum PermissionAccessLevel {
  FULL = 'full',
  VIEW = 'view',
  NONE = 'none',
}

export const sortedPermissionAccessLevels = [
  PermissionAccessLevel.NONE,
  PermissionAccessLevel.VIEW,
  PermissionAccessLevel.FULL,
];

export const dataAccessPermissionAccessLevels = [
  PermissionAccessLevel.VIEW,
  PermissionAccessLevel.FULL,
];

export enum PermissionScope {
  ACCOUNT = 'account',
  SITE = 'site',
  FIRM = 'firm',
  ROLE = 'role',
  USER = 'user',
}

export const aclAllValue = 'all';
